import React, { useEffect, useState } from "react";
import { getYouTubeVideoId } from "../../../common/commonHelpers";
import {
  BACKEND_BASE_URL,
  PORTAL_BACKEND_BASE_URL,
} from "../../../common/constant";
import { useDispatch } from "react-redux";
import { useLocation, useParams } from "react-router-dom";
import LoadingSpinner from "../../../Components/Common/LoadingSpinner";
import Slider from "react-slick";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowLeftLong,
  faArrowRightLong,
} from "@fortawesome/free-solid-svg-icons";
import InvertedComma from "../../../assets/image/white-quoter.png";
import BoyAvtar from "../../../assets/image/boyAvtar.png";
import GirlAvtar from "../../../assets/image/girlAvtar.png";
import CareerlineLogo from "../../../assets/image/logo.png";
import RightAdvice from "../../../assets/image/rightadvice.png";
import Akash from "../../../assets/image/ukadmissionday/Akash.jpg";
import Anjaliben from "../../../assets/image/ukadmissionday/Anjaliben.jpg";
import Daxita from "../../../assets/image/ukadmissionday/Daxita.jpg";
import Dhruvi from "../../../assets/image/ukadmissionday/Dhruvi.jpg";
import Jay from "../../../assets/image/ukadmissionday/Jay.jpg";
import Manasvi from "../../../assets/image/ukadmissionday/Manasvi.jpg";
import Manthan from "../../../assets/image/ukadmissionday/Manthan.jpg";
import Parth from "../../../assets/image/ukadmissionday/Parth.jpg";
import Tisha from "../../../assets/image/ukadmissionday/Tisha.jpg";
import Vatsal from "../../../assets/image/ukadmissionday/Vatsal.jpg";
import Article1 from "../../../assets/image/ukadmissionday/article1.png";
import NoIELTS from "../../../assets/image/ukadmissionday/no ielts.jpg";
import Education from "../../../assets/image/ukadmissionday/affordable-education.jpg";
import Scholarship from "../../../assets/image/ukadmissionday/scholarship.jpg";
import BestUniversity from "../../../assets/image/ukadmissionday/best university.jpg";
import NoInterview from "../../../assets/image/ukadmissionday/no interview.jpg";
import Opportunity from "../../../assets/image/ukadmissionday/reserach opportunity.jpg";
import { Element, Link } from "react-scroll";
import UKAdmissionDayForm from "./UKAdmissionDayForm";
import useWindowSize from "../../../Components/hooks/useWindowSize";

const UKAdmissionDayMainRegForm = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { Campaign, StudentID } = useParams();
  const { width } = useWindowSize();

  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };

  const [data, setData] = useState({});
  const [commonEventID, setCommonEventID] = useState(null);
  const [campaignList, setCampaignList] = useState([]);
  const [campaignTypeList, setCampaignTypeList] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showArticle1, setShowArticle1] = useState(false);
  const [showArticle2, setShowArticle2] = useState(false);

  useEffect(() => {
    scrollToTop();
    // AOS.init();
    const fetchHomePage = async () => {
      try {
        setLoading(true);
        const response = await fetch(
          `${BACKEND_BASE_URL}/Master/ManageCMSDetails`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ CMSURL: "CommonEventID" }),
          }
        );
        const data = await response.json();
        if (data.Status === 200) {
          setCommonEventID(data?.Data?.Template);
        } else {
          console.log("Failed to fetch blogs");
        }
      } catch (error) {
        console.log("Error while fetching blogs:", error);
      } finally {
        setLoading(false);
      }
    };

    //Static IDs for Surat & Anand
    if (location.pathname?.includes("surat")) {
      setCommonEventID(162);
    }
    // else if (location.pathname?.includes("anand")) {
    //   setCommonEventID(152);
    // }
    else {
      fetchHomePage();
    }

    // return () => {
    //   dispatch(clearEventID());
    // };
  }, [location.pathname]);

  useEffect(() => {
    if (commonEventID) {
      const fetchData = async () => {
        try {
          setLoading(true);
          const response = await fetch(
            `${PORTAL_BACKEND_BASE_URL}/eventregistration/findbyid?id=${
              commonEventID
              // eventID
              // eventID || commonEventID
            }`
          );
          if (!response.ok) {
            throw new Error("Failed to fetch data");
          }
          const Response = await response.json();
          const result = Response?.Data;
          const updatedVideoUrls = result?.VideoURL.map((item) => {
            const videoId = getYouTubeVideoId(item.VideoURL);
            return { VideoID: videoId, ...item };
          });
          setData({
            BannerImage: result?.BannerImage,
            SideBanner: result?.SideBanner,
            CMSHeader: result?.CMSHeader,
            CMSFooter: result?.CMSFooter,
            EventCourse: result?.EventCourse ? result?.EventCourse : [],
            EventContry: result?.EventContry ? result?.EventContry : [],
            TimeSlotList: result?.TimeSlotList ? result?.TimeSlotList : [],
            VideoURL: updatedVideoUrls ? updatedVideoUrls : [],
            RegisteredPercentage: result?.RegisteredPercentage
              ? result?.RegisteredPercentage
              : null,
            Campaign: Campaign,
            StudentID: StudentID,
          });
        } catch (error) {
          setError(error?.message || "NetWrok Error");
        } finally {
          setLoading(false);
        }
      };
      fetchData();
      // if (StudentID?.toLowerCase() === "add") {
      const getAllCampaigns = async () => {
        try {
          const response = await fetch(
            `${PORTAL_BACKEND_BASE_URL}/eventregistration/CampaignEventWise`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                EventID: commonEventID,
              }),
            }
          );
          if (!response.ok) {
            throw new Error("Network Error fetching campaign types");
          }
          const result = await response.json();
          const dataList = result?.Data;
          const finalResult = dataList?.map((campaign) => {
            return {
              value: campaign.ID,
              label: campaign.CampaignName,
              CampaignTypeID: campaign.CampaignTypeID,
              CampaignURL: campaign.CampaignURL,
            };
          });
          setCampaignList(finalResult || []);
        } catch (error) {
          console.error("Error fetching campaign:", error);
        }
      };
      const getAllCampaignTypes = async () => {
        try {
          const response = await fetch(
            `${PORTAL_BACKEND_BASE_URL}/eventregistration/CampaignTypeEventWise`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                EventID: commonEventID,
              }),
            }
          );
          if (!response.ok) {
            throw new Error("Network Error fetching campaign types");
          }
          const result = await response.json();
          const dataList = result?.Data;
          const finalResult = dataList?.map((campaign) => {
            return {
              value: campaign.CampaignTypeID,
              label: campaign.CampaignTypeName,
            };
          });
          setCampaignTypeList(finalResult || []);
        } catch (error) {
          console.error("Error fetching campaign:", error);
        }
      };
      getAllCampaigns();
      getAllCampaignTypes();
      // }
    }
  }, [commonEventID]);
  // }, [eventID]);
  // }, [eventID, homeData]);

  const PrevArrow = (props) => {
    const { className, style, onClick } = props;
    return (
      <div
        style={{
          position: "absolute",
          height: 45,
          width: 45,
          background: "white",
          borderRadius: "8px",
          color: "#414c68",
          boxShadow: "0 0 10px lightgray",
        }}
        className="testimonial-prev-arrow"
        onClick={onClick}
      >
        <FontAwesomeIcon
          className={className}
          width={50}
          style={{
            ...style,
            width: "30px",
            height: "30px",
            color: "black",
          }}
          icon={faArrowLeftLong}
        />
      </div>
    );
  };

  const NextArrow = (props) => {
    const { className, style, onClick } = props;
    return (
      <div
        style={{
          position: "absolute",
          height: 45,
          width: 45,
          background: "white",
          borderRadius: "8px",
          color: "#414c68",
          boxShadow: "0 0 10px lightgray",
        }}
        className="testimonial-next-arrow"
        onClick={onClick}
      >
        <FontAwesomeIcon
          className={className}
          width={50}
          style={{
            ...style,
            width: "30px",
            height: "30px",
            color: "black",
          }}
          icon={faArrowRightLong}
        />
      </div>
    );
  };

  const settings = {
    //   dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 3000,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const testimonialData = [
    {
      img: `${BoyAvtar}`,
      description:
        "I had an excellent experience working with Careerline. Their team was highly knowledgeable, professional, and supportive throughout the entire process. From shortlisting universities/countries to assisting with the application process and visa documentation, they made every step seamless and stress-free. All thanks to Hetal ma'am and Kishan sir to support on each and every step to complete the processes seamless.",
      name: "Aakash Patel",
      pragram:
        "Msc Business With Business Analytics With Advanced Practice (London)",
      university: "Northumbria University (London Campus)",
      intake: "FEB_2025",
      country: "UK",
      background: "linear-gradient(45deg, goldenrod, rgb(187, 52, 56))",
    },
    {
      img: `${GirlAvtar}`,
      description:
        "I had an excellent experience with the career line for my UK visa application and consultation. From the beginning, their team was highly professional, knowledgeable, and supportive throughout the entire process. They provided clear guidance on the required documents, helped me understand the visa requirements, and ensured my application was complete and accurate. Their prompt responses and attention to detail made the entire process smooth and stress-free. Thanks to their expertise, specially Miss Twinkle Zalavadiya ma'am for always being there for me in my visa process. My visa application was successful without any delays or complications. I truly appreciate their dedication and would highly recommend their services to anyone looking for reliable UK visa consultation. Thank you all the team members of carrerline nikol and Memmagar branch.",
      name: "Daxita Raghvani",
      pragram: "MSc Public Health",
      university: "London Metropolitan University",
      intake: "JAN_2025",
      country: "UK",
      background: "linear-gradient(45deg, #c09500, goldenrod)",
    },
    {
      img: `${GirlAvtar}`,
      description: `Careertine Education Foundation Nikol is the right place for students like me to achieve their desired scores and to fulfill their dreams to study abroad. Special thanks to tyer sir and Mihir sir for helping me throughout the journey at Careertine and also thanks to Roshani mem and Vrutik sir who give not only the right advice but also make my whole visa process so smooth. I highly recommend Careerline Foundation because they give students "Har kadam pe right advice".`,
      name: "Dhruvi Rathod",
      pragram:
        "Master of Science Information Technology Management (Work Experience)",
      university: "Sheffield Hallam University",
      intake: "JAN_2025",
      country: "UK",
      background: "linear-gradient(45deg, rgb(101 154 255), rgb(38, 78, 154))",
    },
    {
      img: `${GirlAvtar}`,
      description:
        "I want to thank Vrutik Bhatt and the Careertine Education Foundation team for their amazing support for my dream of the UK Visa process. They made the process much easier. I'm also grateful to Miss Hetal for ber invaluable guidance during the university interview process. She helped me to prepare for every aspect of the interview, from the questions to my overall presentation. Her expert advice and support gave me the confidence that I needed to succeed. The team was very supportive and guided me through every step, from applying to getting my visa. What's more, even after I moved to the UK, they continued to support me from India, answering all my questions and providing reassurance whenever I needed it. I highly recommend Careerline Education Foundation to anyone who needs help with their UK application. They're very knowledgeable and make the process less stressful.",
      name: "Anjaliben Makwana",
      pragram: "Master of Science in Digital Marketing",
      university: "Northumbria University (London Campus)",
      intake: "JAN_2025",
      country: "UK",
      background: "linear-gradient(45deg, goldenrod, rgb(187, 52, 56))",
    },
    {
      img: `${BoyAvtar}`,
      description: `Recently I got my UK visa, and I want to extend my heartfelt thanks to the Career Line Education Foundation for their incredible support. Their commitment to enhancing educational opportunities has made a significant impact on my career journey. The resources and guidance provided have been invaluable, helping me to navigate my path with confidence. Especially, I am thankful to Hetal Ma'am and Twinkle Ma'am and their team for their support. I am grateful for the opportunities and learning new things. Thank you for believing in me and for all that you do! "Har Kadam Par Right Advice"`,
      name: "Jay Patel",
      pragram: "BA (Hons) Business Management with International Year One",
      university: "University of East Anglia",
      intake: "SEPT_2024",
      country: "UK",
      background: "linear-gradient(45deg, #c09500, goldenrod)",
    },
    {
      img: `${BoyAvtar}`,
      description: `I am incredibly grateful to Careerline for their outstanding support in helping me secure my UK visa. A special thanks to Hetal ma'am and Twinkle Ma'am for their expert guidance, which ensured every step of the application process was smooth and stress-free. From document preparation to interview coaching, your personalized service and responsiveness were invaluable. Thanks to Careerline, I am now ready to pursue my academic dreams in the UK. I highly recommend Careertine Education Foundation for consulting study abroad, as per their promise and slogan they provide #हरकदमपेrightadvis`,
      name: "Manthan Pandya",
      pragram: "MBA",
      university: "Ravensbourne University London",
      intake: "SEPT_2024",
      country: "UK",
      background: "linear-gradient(45deg, rgb(101 154 255), rgb(38, 78, 154))",
    },
    {
      img: `${GirlAvtar}`,
      description: `My name is Tisha Ghediya. I am from Jamnagar, Gujarat. I have applied for an MSc in analytical chemistry at Sheffield Hallam University. I am incredibly grateful to Careerline Education for their outstanding service. A special thanks to Vrutik sir and Roshni mam. They helped me genuinely. I received my visa in just one day without any complications. Once again thank you so much for the smooth process.`,
      name: "Tisha Ghediya",
      pragram: "Masters in Analytical Chemistry",
      university: "Sheffield Hallam University",
      intake: "SEPT_2024",
      country: "UK",
      background: "linear-gradient(45deg, goldenrod, rgb(187, 52, 56))",
    },
    {
      img: `${GirlAvtar}`,
      description: `Careerline Foundation Nikol is the best preparation place for IELTS because of their resource availability and management. I had the best experience at the foundation which got me the best results. I'm extremely grateful to the staff and especially lyer sir for being the best mentor and supporter during my IELTS journey. I would also like to thank Roshni Ma'am and Vrutik sir for making the visa process so smooth and I appreciate their efforts they gave in during the process.`,
      name: "Manasvi Patel",
      pragram: "BSc Hons Biomedical Science",
      university: "University of Strathclyde",
      intake: "SEPT_2024",
      country: "UK",
      background: "linear-gradient(45deg, #c09500, goldenrod)",
    },
    {
      img: `${BoyAvtar}`,
      description: `I want to thank you specially vrutik sir & hetal mam and Twinkal mam and careeline education team for their amazing support for my dream of the UK Visa process. They made the process much easier. I'm also grateful to Miss Hetal for her invaluable guidance during the university interview process. She helped me to prepare for every aspect of the interview, from the questions to my overall presentation. Her expert advice and support gave me the confidence which I needed to succeed. The team was very supportive and guided me through every step, from applying to getting my visa What's more, even after I moved to the UK, they continued to support me from India, answering all my questions and providing reassurance whenever I needed it. I highly recommend Careerline Education Foundation to anyone who needs help with their UK application. They're very knowledgeable and make the process less stressful. Thank you so much sir and mam`,
      name: "Parth Patel",
      pragram: "MSc Cyber Security",
      university: "De Montfort University",
      intake: "JAN_2025",
      country: "UK",
      background: "linear-gradient(45deg, rgb(101 154 255), rgb(38, 78, 154))",
    },
    {
      img: `${BoyAvtar}`,
      description: `I had an excellent experience with Careerline! From the initial consultation to the final stages of my application process, their team was incredibly professional, knowledgeable, and supportive. They provided clear guidance on choosing the right universities and programs tailored to my academic and career goals. Vrutikbhal And Roshni Ma'am were always available to answer my questions, address my concerns, and provide timely updates. Their expertise in navigating visa processes and scholarship opportunities was invaluable. Thanks to their help. I highly recommend the Careerline Education Foundation to anyone looking to study abroad. Their dedication and personalized service truly make a difference!`,
      name: "Vatsal Makwana",
      pragram:
        "Pre-Masters Programme (Business: Management and Marketing) leading to Accountancy and Finance Msc",
      university: "University of Huddersfield",
      intake: "SEPT_2024",
      country: "UK",
      background: "linear-gradient(45deg, #c09500, goldenrod)",
    },
  ];

  const testimonialImages = [
    { image: Akash },
    { image: Anjaliben },
    { image: Daxita },
    { image: Dhruvi },
    { image: Jay },
    { image: Manasvi },
    { image: Manthan },
    { image: Parth },
    { image: Tisha },
    { image: Vatsal },
  ];

  if (loading) {
    return <LoadingSpinner />;
  }

  return (
    <div>
      <Link
        className={`ukadmissionday-banner-section ${
          location.pathname?.includes("surat")
            ? "surat-banner"
            : // : location.pathname?.includes("anand")
              // ? "anand-banner"
              ""
        }`}
        activeClass="active"
        to="test1"
        offset={-120}
        duration={300}
      ></Link>
      <Element
        name="test1"
        className="ukadmissionday-reg-form mt-3"
        id="event-registration-section"
      >
        <UKAdmissionDayForm
          data={data}
          CommonEventID={commonEventID}
          campaignList={campaignList}
          campaignTypeList={campaignTypeList}
          setLoading={setLoading}
        />
      </Element>
      <div className="ukadmissionday-attend-section">
        <h1
          className="text-center mt-5 mb-5"
          style={{ fontWeight: 500, color: "#000" }}
        >
          Why Attend?
        </h1>
        <div className="container mb-5">
          <div className="row">
            <div className="col-md-6 col-lg-4 d-flex">
              <img src={NoIELTS} alt="Image" className="img-fluid" />
              <div className="box d-flex align-items-center">
                <h5 className="m-0">Apply Without IELTS/PTE/TOEFL</h5>
              </div>
            </div>
            <div className="col-md-6 col-lg-4 d-flex">
              <img src={Education} alt="Image" className="img-fluid" />
              <div className="box d-flex align-items-center">
                <h5 className="m-0">Affordable Fees</h5>
              </div>
            </div>
            <div className="col-md-6 col-lg-4 d-flex">
              <img src={Scholarship} alt="Image" className="img-fluid" />
              <div className="box d-flex align-items-center">
                <h5 className="m-0">Attractive Scholarships</h5>
              </div>
            </div>
            <div className="col-md-6 col-lg-4 d-flex">
              <img src={BestUniversity} alt="Image" className="img-fluid" />
              <div className="box d-flex align-items-center">
                <h5 className="m-0">Top-Ranked Universities</h5>
              </div>
            </div>
            <div className="col-md-6 col-lg-4 d-flex">
              <img src={NoInterview} alt="Image" className="img-fluid" />
              <div className="box d-flex align-items-center">
                <h5 className="m-0">No Interview Required</h5>
              </div>
            </div>
            <div className="col-md-6 col-lg-4 d-flex">
              <img src={Opportunity} alt="Image" className="img-fluid" />
              <div className="box d-flex align-items-center">
                <h5 className="m-0">Reserach Opportunities with Dependents</h5>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="ukadmissionday-hero-section">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <h3 className="event-hero-label">Event Details</h3>
              <div className="event-details-info mt-5">
                <p className="fw-bold">Where & when</p>
                <div className="d-sm-flex">
                  <div className="d-flex gap-2 align-items-center mb-3 w-sm-50 w-100">
                    <i
                      className="bi bi-calendar-minus"
                      style={{ color: "#F50C2A", fontSize: 25 }}
                    ></i>
                    {location.pathname?.includes("surat") ? (
                      <p className="m-0">
                        <span className="fw-bold">Date & Time</span>
                        <br />
                        June 19, 2025 <br />
                        04:30 PM to 06:00 PM
                      </p>
                    ) : (
                      // : location.pathname?.includes("anand") ? (
                      //   <p className="m-0">
                      //     <span className="fw-bold">Date & Time</span>
                      //     <br />
                      //     May 16, 2025 <br />
                      //     03:00 PM to 08:00 PM
                      //   </p>
                      // )
                      <p className="m-0">
                        <span className="fw-bold">Date & Time</span>
                        <br />
                        June 21, 2025 <br />
                        05:00 PM to 07:00 PM
                      </p>
                    )}
                  </div>
                  <div className="d-flex gap-2 align-items-center w-sm-50 w-100">
                    <i
                      className="bi bi-geo-alt"
                      style={{ color: "#F50C2A", fontSize: 25 }}
                    ></i>
                    <p className="m-0">
                      <span className="fw-bold">Location</span>
                      <br />
                      {/* Careerline Education, 601-608, AWS-III Block-A, Nr. Manav
                      Mandir, Memnagar Ahmedabad. */}
                      {location.pathname?.includes("surat")
                        ? `Careerline Education, S-15, 3rd Floor, Central Plaza, Beside Om Terrace, Nr. DRB college, New City Light, Surat 395007.`
                        : // : location.pathname?.includes("anand")
                          // ? `Careerline Education, c/o Vayunandan Travels & Consultants, 2nd Floor, 203,204,205 - Radha Swami Sukrut, Nr. D- mart, V.V Nagar, Anand 388120.`
                          // `Careerline Education, 601-608, AWS-III Block-A, Nr. Manav Mandir, Memnagar Ahmedabad 380052.` // Manav Mandir
                          `Careerline Education, 215-216 Town Plaza, Nr Raspan Arcade, Nikol, Ahmedabad 382350.`}
                      {/* Nikol */}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="ukadmissionday-article-section">
        <h1
          className="text-center mt-5 mb-5 "
          style={{ fontWeight: 500, color: "#000" }}
        >
          Articles
        </h1>
        <div className="container">
          <div className="section">
            <h3>
              • UK Labour Shortages 2025: Opportunities for International Talent
            </h3>
            <p>
              The United Kingdom presents promising post-study work
              opportunities for international students, particularly in light of
              the current skilled labor shortages across various high-demand
              sectors such as Finance, Mining, Construction, Information
              Technology, Health Services, and many others.
              {width <= 992 && !showArticle1 && (
                <span
                  className="read-more-btn"
                  onClick={() => setShowArticle1(!showArticle1)}
                >
                  ..Read More"
                </span>
              )}
            </p>

            {(width > 992 || showArticle1) && (
              <>
                <p>
                  The Graduate Visa (PSW), introduced in July 2021, allows
                  international graduates to remain in the UK for two years
                  (three years for doctoral graduates) to work or seek
                  employment. This visa route offers a pathway to long-term
                  employment and potentially settlement (Indefinite Leave to
                  Remain) in the UK.
                </p>

                <p>
                  According to a survey by the British Chambers of Commerce, 82%
                  of companies are struggling to get Skilled Labour and as per
                  the ONS (Office for National Statistics) data has revealed
                  that nearly one third of UK businesses are experiencing labour
                  shortages after an increase in economic inactivity. These
                  skill job shortages are not only hindering business growth but
                  are also significantly impacting the UK economy.
                </p>

                <p>
                  A Rise in Early Retirements, the ONS surveyed adults aged
                  between 50 and 70 who had left the workforce since the
                  beginning of the pandemic. The survey found that 63% of them
                  had left work sooner than expected, leading to a decrease in
                  skilled workers across various industries. The Construction
                  Products Association estimates that the industry will lose
                  500,000 employees, representing 25% of the total workforce, to
                  retirement over the next 10 to 15 years.{" "}
                  {width <= 992 && showArticle1 && (
                    <span
                      className="read-more-btn"
                      onClick={() => setShowArticle1(!showArticle1)}
                    >
                      Show less
                    </span>
                  )}
                </p>
              </>
            )}
          </div>

          {/* <div className="image-section">
              <img src={Article1} alt="UK Labour Shortage" />
            </div> */}

          <div className="section">
            <h3>• Indians in the UK Job Market</h3>
            <p>
              Indian nationals are leading in skilled worker and student visas
              issued by the UK, according to official immigration statistics
              from the Office for National Statistics (ONS). The data shows that
              Indians were the top nationality for cross-sector skilled work,
              including healthcare visas aimed at addressing staff shortages in
              the National Health Service (NHS).
              {width <= 992 && !showArticle2 && (
                <span
                  className="read-more-btn"
                  onClick={() => setShowArticle2(!showArticle2)}
                >
                  ..Read More"
                </span>
              )}
            </p>
            {(width > 992 || showArticle2) && (
              <>
                <p>
                  Britain will invest 600 million pounds ($775 million) to train
                  construction workers and help tackle severe skills shortages
                  that could undermine its plan to build 1.5 million homes by
                  2029 and boost economic growth.
                </p>

                <p>
                  The UK currently faces a staggering shortfall of over 173,000
                  STEM (Science, Technology, Engineering, and Mathematics)
                  workers, costing the UK economy an estimated £1.5bn annually.
                  This shift shows high demand for candidates with skills in the
                  sector. Research by CIPD (Chartered Institute of Personnel and
                  Development) revealed that 55% of recruiters plan to raise the
                  minimum wage this coming year.
                </p>

                <p>
                  This shift opens doors for the UK's skilled labour shortages
                  present a unique opportunity for Indian graduates to embark on
                  rewarding careers abroad. By strategically aligning their
                  skills with in-demand sectors and navigating the visa
                  processes effectively, Indian professionals can contribute
                  meaningfully to the UK's workforce.
                  {width <= 992 && showArticle2 && (
                    <span
                      className="read-more-btn"
                      onClick={() => setShowArticle2(!showArticle2)}
                    >
                      Show less
                    </span>
                  )}
                </p>
              </>
            )}
          </div>
        </div>
      </div>
      <div className="ukadmissionday-testimonials event-testimonials">
        <div className="container pt-5 pb-5">
          <div className="row">
            <p className="fw-600">30000+ Success Stories</p>
            <div className="col-12 mb-5">
              <h3 className="event-testimonials-label">
                From Dreamers{" "}
                <span className="testimonial-hightlight">to Achievers</span>
              </h3>
            </div>
            <div className="testimonials-list ">
              <Slider className="owl-carousel popular owl-theme" {...settings}>
                {testimonialImages.map((item, index) => (
                  <div key={index} className="item pt-3">
                    <img
                      src={item.image}
                      alt="Testimonial Image"
                      style={{
                        borderRadius: "20px",
                        borderTop: "2px solid #F50C2A",
                        borderLeft: "2px solid #002591",
                        borderRight: "2px solid #F50C2A",
                        borderBottom: "2px solid #002591",
                      }}
                    />
                  </div>
                ))}
                {/* {testimonialData.map((item, index) => (
                  <RenderTestimonialCardNew
                    key={index}
                    uniqueKey={index}
                    description={item?.description}
                    img={item?.img}
                    name={item?.name}
                    background={item?.background}
                    university={item?.university}
                    pragram={item?.pragram}
                    intake={item?.intake}
                    country={item?.country}
                  />
                ))} */}
              </Slider>
            </div>
          </div>
        </div>
      </div>
      <div className="event-footer">
        <div className="container pt-5 pb-5">
          <div className="row">
            <div className="col-12 d-flex justify-content-between pb-5 footer-imgs">
              <img src={CareerlineLogo} alt="logo" />
              <img src={RightAdvice} alt="logo" />
            </div>
            <div className="col-sm-12 col-md-6 col-lg-3 mb-5">
              <h3>Contact us</h3>
              <div className="footer-top-para-right">
                <p className="pb-3">
                  <i className="bi bi-envelope" />
                  <a href="mailto:admin@careerline.org">admin@careerline.org</a>
                </p>
                <i className="bi bi-telephone-plus" />
                <a
                  href="tel:6358989872"
                  // contentEditable="false"
                  style={{ cursor: "pointer" }}
                >
                  +91-6358989872
                </a>
              </div>
              <div className="footer-socialmedia mt-4">
                <a
                  href="https://www.facebook.com/CareerlineEF/"
                  target="_blank"
                >
                  <i className="bi bi-facebook" />
                </a>
                <a href="https://twitter.com/Careerlineef" target="_blank">
                  <i className="bi bi-twitter" />
                </a>
                <a
                  href="https://www.linkedin.com/company/careerlineef/"
                  target="_blank"
                >
                  <i className="bi bi-linkedin" />
                </a>
                <a
                  href="https://www.youtube.com/c/CareerlineEducationFoundation/"
                  target="_blank"
                >
                  <i className="bi bi-youtube" />
                </a>
                <a
                  href="https://www.instagram.com/careerlineef/"
                  target="_blank"
                >
                  <i className="bi bi-instagram" />
                </a>
              </div>
            </div>
            <div className="col-sm-12 col-md-6 col-lg-9 ">
              <iframe
                src={
                  location.pathname?.includes("surat")
                    ? "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3720.981915240616!2d72.7953405758748!3d21.153117983494425!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be04fccc4346f61%3A0x157879627c8a11cd!2sCareerline%20Education%20Foundation!5e0!3m2!1sen!2sin!4v1735712418724!5m2!1sen!2sin"
                    : // : location.pathname?.includes("anand")
                      // ? "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3684.8793440638974!2d72.9291155!3d22.546192100000003!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x395e4d499fed792f%3A0xcfc4862a06d8a9a1!2sCareerline%20Education%20Foundation!5e0!3m2!1sen!2sin!4v1739274051915!5m2!1sen!2sin"
                      // "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d12349.140012101447!2d72.53275668773627!3d23.045011391639978!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x395e848ac8a7faf3%3A0x605d0c100abfcc1a!2sCareerline%20Education%20Foundation!5e0!3m2!1sen!2sin!4v1724236290085!5m2!1sen!2sin"
                      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3671.2835038042363!2d72.66991247591253!3d23.050065615300525!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x395e87327045605f%3A0x3debbad8cbaa305f!2sCareerline%20Education%20Foundation!5e0!3m2!1sen!2sin!4v1748251967842!5m2!1sen!2sin"
                }
                width={"100%"}
                height={200}
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const RenderTestimonialCardNew = (props) => {
  return (
    <div key={props.uniqueKey} className="item pt-3">
      <div className="testimonials" style={{ background: "white" }}>
        <div
          className="testimonials-item-top p-3 position-relative"
          style={{ background: props?.background }}
        >
          <div
            className="testimonials-item-effect"
            style={{ background: props.effectColor }}
          ></div>
          <div className="testimonials-item-desc">
            <img
              src={InvertedComma}
              style={{ marginRight: 25, display: "inline" }}
            />
            {props.description}{" "}
            <img
              src={InvertedComma}
              style={{
                marginLeft: 25,
                display: "inline",
                transform: "rotate(180deg)",
              }}
            />
          </div>
        </div>
        <div className="testimonials-item-bottom  p-3">
          <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
            <div>
              <img
                src={props.img}
                alt="Student img"
                className="img-fluid"
                style={{
                  height: 48,
                  width: 48,
                  objectFit: "cover",
                  borderRadius: "50%",
                }}
              />
            </div>
            <div style={{ fontSize: 12, display: "flow-root", flex: 1 }}>
              <span className="fw-bold" style={{ fontSize: 15 }}>
                {props.name}, {props.country}
              </span>
              <br />
              <span>{props.pragram}</span>, <br />
              at&nbsp;<span>{props.university}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UKAdmissionDayMainRegForm;
